const resolveLink = ( rawPath ) => {
    // If it starts with en/ then remove it. If not, keep original
    let path = rawPath?.slice(0,3) === "en/" && rawPath !== undefined ? rawPath?.slice(3) : rawPath
    return `/${path?.replace(/\/$|$/, `/`)}`
}
export default resolveLink